import React, { useState } from "react";
import CompanyNavbar from "./CompanyNavbar";
import Cookies from "js-cookie";
import axios from "axios";
import url from "../../function/url";
import Swal from "sweetalert2";
function CompanyHighlight() {
    const ID = Cookies.get("log_id");
    const [position,setPosition] = useState("");
    const [from,setFrom] = useState("");
    const [to,setTo] = useState("");
    const [reason,setReason] = useState("");
    const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.onmouseenter = Swal.stopTimer;
          toast.onmouseleave = Swal.resumeTimer;
        },
    });
    function Highlight(e) {
        e.preventDefault();
        const formdata = new FormData();
        formdata.append('id',ID);
        formdata.append('position',position);
        formdata.append('from',from);
        formdata.append('to',to);
        formdata.append('reason',reason);
        axios.post(`${url.path}/company_highlight/`,formdata)
        .then((res) =>{
            if(res.data.status){
                Toast.fire({
                    icon:'success',
                    title:'Highlight Request Submitted..'
                })
            }   
        }).catch((err) => {
            console.log("ERROR", err);
            if (!err.response.data.status) {
                Toast.fire({
                  icon: "error",
                  title: `${err.response.data.message}`,
                });
              }
          }); 
    }
    return(
        <>
        <CompanyNavbar />
        <div className="content">
            
            <div className="form-container">
                <div id="ndiv">
                    <h1 style={{fontSize:'30px'}}>Company Highlight</h1>
                </div>
                <br />
                <form onSubmit={Highlight}>
                    <div className="form-group-row">
                        <div className="form-group">
                            <label>Desired Position</label>
                            <select value={position} onChange={(e) =>setPosition(e.target.value)}>
                                <option selected>--Select--</option>
                                <option value="1st">1st</option>
                                <option value="2nsd">2nd</option>
                                <option value="3rd">3rd</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label>From</label>
                            <input type="date" value={from} onChange={(e) =>setFrom(e.target.value)} />
                            
                        </div>
                        <div className="form-group" >
                            <label>To</label>
                            <input type="date" value={to} onChange={(e) =>setTo(e.target.value)} />
                            
                        </div>
                        <div className="form-group">
                            <label>Reason</label>
                            <input type="text" style={{height:'80px'}} value={reason} onChange={(e) =>setReason(e.target.value)}  />
                        </div>
                    </div>
                    <center>
                        <div className="row">
                            <button style={{ width:'150px',height:'40px',borderRadius:'10px',color:'black',backgroundColor:'gainsboro'}} type="submit">Request</button>
                        </div>
                    </center>
                </form>
                
            </div>

        </div>
        </>
    );
}
export default CompanyHighlight;